import { render, staticRenderFns } from "./frontpage.vue?vue&type=template&id=2ae0ad4f&scoped=true"
import script from "./frontpage.vue?vue&type=script&lang=js"
export * from "./frontpage.vue?vue&type=script&lang=js"
import style0 from "./frontpage.vue?vue&type=style&index=0&id=2ae0ad4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0ad4f",
  null
  
)

export default component.exports